import script from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TechStackSection.vue?vue&type=script&setup=true&lang=js"

import "./TechStackSection.vue?vue&type=style&index=0&id=4231a180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4231a180"]])

export default __exports__